import * as React from "react";
import { NativeAdContainerRegionFTNodeOptions, NativeAdContainerRegionProps } from "./typings";
import { NativeAd } from "components/utility/Ads/NativeAd";
import { logger } from "bernie-core";
import { SpacingSize } from "src/components/utility/FlexAttributesUtil";
import { UitkSpacing } from "uitk-react-spacing";
import {
  hasEmptyOptions,
  hasRenderableChilren,
  normalizeOptionsData,
} from "src/components/flexFramework/FlexTemplateNode";
import { withStores } from "stores";
import { observer } from "mobx-react";

/**
 * Native Ad Container Region wraps its children and first attempts to make a request for an ad based on the uci defined in Flex manager.
 * The children components of the region will be serve as the fallback of the of the Ad component, logic to show the fallback or ad is contained
 * in the NativeAd component (see link below).
 * @see https://github.expedia.biz/Flex/blossom-flex-ui/blob/master/src/components/utility/Ads/NativeAd.tsx
 * @see https://pages.github.expedia.biz/Flex/blossom-flex-ui-documentation/docs/Domains_within_Blossom/Storefront_BEX_+_COMET/Native_Ad_Container/
 * @see https://github.expedia.biz/MediaSolutions/ads-delivery-service/wiki
 */

export const NativeAdContainerRegionComponent = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: NativeAdContainerRegionProps) => {
    const { context, flexModuleModelStore, flexTemplateNode, blossomComponent, logger, l10n } = props;

    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(flexTemplateNode.id)
    ) as NativeAdContainerRegionFTNodeOptions;

    if (
      !blossomComponent ||
      hasEmptyOptions(options) ||
      !hasRenderableChilren(flexTemplateNode, flexModuleModelStore)
    ) {
      return null;
    }

    const { uci, padding } = options;

    const children = blossomComponent.renderChildren(logger, l10n, context);
    const hasNoPadding = padding === SpacingSize.NONE;
    const blockStartSpacing = hasNoPadding ? "unset" : "three";

    return (
      <div className="NativeAdContainerRegion NativeCardPadding" id={`native-ad-${uci}`}>
        <UitkSpacing padding={{ blockstart: blockStartSpacing }}>
          <NativeAd uci={uci} type="native-ad">
            {children}
          </NativeAd>
        </UitkSpacing>
      </div>
    );
  })
);

export const NativeAdContainerRegion = logger("NativeAdContainerRegion")(NativeAdContainerRegionComponent);

export default NativeAdContainerRegion;
